const ENDPOINT = "/api/albero-api";
const PASSWORD_KEY = "albero_session_password";

export const getPassword = () => sessionStorage.getItem(PASSWORD_KEY) || "";
export const setPassword = (value) => sessionStorage.setItem(PASSWORD_KEY, value || "");
export const clearPassword = () => sessionStorage.removeItem(PASSWORD_KEY);

async function call(action, data = {}) {
  const password = getPassword();
  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Albero-Password": password,
    },
    body: JSON.stringify({ action, data }),
  });

  let payload = null;
  try {
    payload = await res.json();
  } catch {
    throw new Error("Risposta non valida dal server");
  }

  if (res.status === 401) {
    clearPassword();
    throw new Error("PASSWORD_ERRATA");
  }
  if (!res.ok || !payload?.ok) {
    throw new Error(payload?.error || `Errore server (${res.status})`);
  }
  return payload.data;
}

export const verify = () => call("health");
export const listVoci = () => call("listVoci");
export const saveVoce = (item) => call("saveVoce", item);
export const listClienti = () => call("listClienti");
export const saveCliente = (client) => call("saveCliente", client);
export const listPreventivi = () => call("listPreventivi");
export const getPreventivo = (fileId) => call("getPreventivo", { fileId });
export const savePreventivo = (quote) => call("savePreventivo", { quote });
